// base-url.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only prepend if the request URL is relative.
    if (!req.url.startsWith('http')) {
      const apiReq = req.clone({
        url: environment.serverUrl + '/api' + req.url,
      });
      return next.handle(apiReq);
    }
    return next.handle(req);
  }
}
